var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnlyIconApple = function SvgOnlyIconApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#222",
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.606 22.353q-.435 1.004-1.03 1.853-.814 1.159-1.328 1.604-.795.73-1.706.752-.656 0-1.576-.377-.922-.375-1.696-.375-.812 0-1.745.375-.934.378-1.507.397-.876.038-1.745-.772-.556-.484-1.389-1.66-.892-1.257-1.468-2.917-.616-1.794-.616-3.476 0-1.927.833-3.32a4.9 4.9 0 0 1 1.746-1.766 4.7 4.7 0 0 1 2.36-.666q.694.001 1.825.425 1.13.424 1.448.425.239 0 1.606-.501 1.29-.464 2.182-.387 2.42.194 3.63 1.91-2.164 1.312-2.142 3.668.02 1.835 1.329 3.05.591.561 1.327.87-.16.463-.338.888M21.908 7.8q0 1.44-1.049 2.682c-.842.985-1.86 1.554-2.966 1.464a3 3 0 0 1-.022-.363c0-.92.4-1.905 1.112-2.71a4.3 4.3 0 0 1 1.355-1.017q.82-.4 1.55-.44.02.194.02.384"
  })));
};
export default SvgOnlyIconApple;